import React, { useEffect, useState } from "react";
import Circles from "../components/Circles";
import Button from "../components/Button";
import ProgressBar from "../components/ProgressBar";
import questionMarkSyren from "../assets/question-mark.svg";
import questionMarkGreen from "../assets/question-mark-green.svg";
import { usePoints } from "../providers/PointsContext";
import { useCurrentPage } from "../providers/CurrentPageContext";
import arrow_syren from "../assets/arrow_syren.svg";
import arrow_petrol from "../assets/arrow_petrol.svg";
function Question({
  loading,
  error,
  questions,
  gameId,
  saveAnswer,
  setSaveAnswer,
  setChallengeQuestionAnswer
}) {
  const [answer, setAnswer] = useState(null);
  const [questionIndex, setQuestionIndex] = useState(0);
  const [currentPage, setCurrentPage] = useCurrentPage();
  const [points, setPoints] = usePoints();
  const [time, setTime] = useState(0);
  const [selectedAnswer, setSelectedAnswer] = useState(null);

  const oddEvenQuestion = questionIndex % 2 === 0 ? false : true;

  // const [saveAnswer, setSaveAnswer] = useState({});
  useEffect(() => {
    if (gameId === null) return;
    const saveAnswer = {
      session_id: gameId,
    };
    setSaveAnswer(saveAnswer);
  }, [gameId]);
  
  useEffect(() => {
    setTime(new Date().getTime());
  }, []);

  return (
    <section className={"w-full" && (oddEvenQuestion ? "bg-petrol-500" : "bg-syren-500")} style={{transition: 'all 500ms',height:"100dvh",maxHeight: '100dvh'}}>
      {loading && <p className="text-center">Laddar...</p>}
      {error && <p className="text-center">Något gick fel...</p>}
      {questions && (
        <div className="container">
          <div className="w-full mb-8 sm:mb-10"> {/**  mb-24 */}
            {questions && <ProgressBar questionIndex={questionIndex} />}
          </div>
          <div className="relative inline-block mx-auto mb-4">
            <p className="font-bold text-center">
              Fråga {questionIndex + 1} av 10
            </p>
            {/*<img
              src={oddEvenQuestion ? questionMarkGreen : questionMarkSyren}
              alt="question mark"
              className="absolute bottom-5 left-full translate-x-1"
      />*/}
          </div>
          <header className="mb-6">
            {questions && questions[questionIndex] && (
              <h1 className="sm:text-[2.6rem] text-[1.6rem]">{questions[questionIndex].question}</h1>
            )}
          </header>

          <div class="flex flex-col items-center justify-center w-auto mt-auto space-y-5 sm:space-y-3 min-w-80">
            {questions[questionIndex].answers.map((answer, index) => (
              <Button
                key={index}
                onClick={(e) => selectAnswer(e, index)}
                text={answer}
                buttonClass={`answerbutton ${selectedAnswer === index
                  ? oddEvenQuestion
                    ? "answerbutton bg-petrol-300 border-petrol-300"
                    : "answerbutton bg-syren-300 border-syren-300"
                  : ""}`}
              />
            ))}
          </div>
          <button
            className={`${oddEvenQuestion ? "primary" : "next"} submitAnswer mt-[50px] disabled:opacity-50 disabled:cursor-not-allowed w-full`}
            disabled={answer === null || undefined}
            onClick={submitAnswer}
          >
            {questionIndex === 9 ? "Se ditt resultat" : "Nästa fråga"}
            <img src={oddEvenQuestion?arrow_petrol: arrow_syren} alt="arrow" className="ml-2" />
          </button>
        </div>
      )}
      <Circles color={oddEvenQuestion ? "bg-petrol" : "bg-syren"} />
    </section>
  );

  function selectAnswer(e, index) {
    setSelectedAnswer(index);
    setAnswer(e.target.innerText);
  }

  function submitAnswer() {
    setSelectedAnswer(null);
    const timeSpent = 30000 - (new Date().getTime() - time);
    const saveAnswers = saveAnswer;
    saveAnswers[`answer${questionIndex + 1}`] = answer;
    saveAnswers[`answer${questionIndex + 1}_time`] = timeSpent;
    setSaveAnswer(saveAnswers);

    if (answer === questions?.[questionIndex].answer1) {
      setPoints((currentPoints) => currentPoints + 1);
    }
    if (questionIndex < 9) {
      setQuestionIndex((current) => current + 1);
      setTime(new Date().getTime());
    } else {
      setChallengeQuestionAnswer("");
      
      console.log("saveAnswer", saveAnswer);
    }
    setAnswer(null);
    console.log(answer, points);
  }
}

export default Question;
